export default "__VITE_ASSET__BkyycFXi__"